import { Injectable, inject } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "@environments/environment";
import { MipsQuestionnaire } from "@models/mips-stepper.model";
import { ReweightingResult } from "@models/mips-reweighting.model";

@Injectable({
  providedIn: "root",
})
export class MipsQuestionnaireService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.apiUrl}/mips`;

  getMipsQuestionnaire(
    orgId: string,
    performanceYear: number
  ): Observable<MipsQuestionnaire> {
    return this.http.get<MipsQuestionnaire>(
      `${this.apiUrl}/questionnaire/${orgId}/${performanceYear}`
    );
  }

  getMipsReweighting(
    orgId: string,
    performanceYear: number
  ): Observable<ReweightingResult> {
    return this.http.get<ReweightingResult>(
      `${this.apiUrl}/reweighting/${orgId}/${performanceYear}`
    );
  }

  submitMipsQuestionnaire(
    data: MipsQuestionnaire,
    orgId: string,
    performanceYear: number
  ): Observable<any> {
    const payload = {
      ...data,
      organizationID: parseInt(orgId, 10),
      measurementYear: performanceYear,
    };
    return this.http.post(`${this.apiUrl}/questionnaire`, payload);
  }

  updateMipsQuestionnaire(
    data: MipsQuestionnaire,
    orgId: string,
    performanceYear: number
  ): Observable<any> {
    const payload = {
      ...data,
      organizationID: parseInt(orgId, 10),
      measurementYear: performanceYear,
    };
    return this.http.put(
      `${this.apiUrl}/questionnaire/${orgId}/${performanceYear}`,
      payload
    );
  }

  exportAllQuestionnaires(
    orgId: string,
    performanceYear: number
  ): Observable<Blob> {
    const params = new HttpParams()
      .set("orgId", orgId)
      .set("performanceYear", performanceYear.toString());

    return this.http.get(`${this.apiUrl}/questionnaire/export`, {
      params,
      responseType: "blob",
      headers: {
        Accept: "text/csv",
      },
    });
  }
}
